import { preloadPostOfficePlacementWithSessionContext } from '@atlassian/confluence-post-office-provider/entry-points/preload-placement';

import type { PreloadFnContext } from '@confluence/query-preloader-tools';

export const preloadPostOfficeConfluenceHomeBanner = (preloadedSessionContext: PreloadFnContext) =>
	preloadPostOfficePlacementWithSessionContext('confluence-home-banner', preloadedSessionContext);
